"use client";

import React, { useRef } from "react";
import { useGoogleAd } from "./execute-add-ad";
import AdWrapper from "./AdWrapper";

declare global {
  interface Window {
    adsbygoogle?: any | any[];
  }
}

function InArticleAdItem() {
  const adsRef = useRef<HTMLModElement | null>(null);

  useGoogleAd(adsRef);

  return (
    <ins
      ref={adsRef}
      className="adsbygoogle"
      style={{
        display: "block",
        border:
          process.env.NODE_ENV === "development" ? "1px solid red" : "none",
        backgroundColor:
          process.env.NODE_ENV === "development"
            ? "rgba(255, 0, 0, 0.1)"
            : "none",
      }}
      data-ad-client="ca-pub-9143210451390429"
      data-ad-layout="in-article"
      data-ad-format="fluid"
      data-ad-slot="9867285140"
    ></ins>
  );
}

export default function InArticleAd() {
  return (
    <AdWrapper>
      <InArticleAdItem />
    </AdWrapper>
  );
}
